import { render, staticRenderFns } from "./tokenCard.vue?vue&type=template&id=98c81f8c&scoped=true&"
import script from "./tokenCard.vue?vue&type=script&lang=js&"
export * from "./tokenCard.vue?vue&type=script&lang=js&"
import style0 from "./tokenCard.vue?vue&type=style&index=0&id=98c81f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c81f8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98c81f8c')) {
      api.createRecord('98c81f8c', component.options)
    } else {
      api.reload('98c81f8c', component.options)
    }
    module.hot.accept("./tokenCard.vue?vue&type=template&id=98c81f8c&scoped=true&", function () {
      api.rerender('98c81f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/operator/tokenCard.vue"
export default component.exports